import { AfterViewInit, Directive, ElementRef, inject, Input } from '@angular/core';

@Directive({
  selector: '[ttAutofocus]',
  standalone: true,
})
export class AutofocusDirective implements AfterViewInit {
  private el = inject(ElementRef);

  private shouldAutofocus = true;

  @Input()
  set ttAutofocus(value: boolean) {
    this.shouldAutofocus = value;
  }

  ngAfterViewInit() {
    if (this.shouldAutofocus) {
      setTimeout(() => {
        (this.el.nativeElement as HTMLElement).focus();
      });
    }
  }
}
